module dg.objects {

    export class ObjectTasksStatusController {
        public object: dg.domain.IDomainObject;

        public iconName: string;
        public className: string;
        public link: dg.restfulApi.Link;

        constructor(private navigationService: dg.navigation.NavigationService) {
            //object
        }

        $onChanges(changes) {

            //ng-if=".taskStatus" link="$ctrl.queryResult.dgMeta.links.tasksStatus"
            if (changes.object.currentValue) {
                let tasksStatus: dg.domain.model.TaskStatus = (<any>this.object).taskStatus;
                if (tasksStatus) {
                    this.link = this.object.dgMeta.links.tasksStatus;

                    if (tasksStatus == 'Failed') {
                        this.iconName = 'fa-exclamation-circle';
                        this.className = 'text-danger';
                    }
                    else if (tasksStatus == 'InProgress') {
                        this.iconName = 'fa-spinner progress-animation';
                        this.className = '';
                    }
                    else {
                        throw Error(`Unsuported tasks status ${tasksStatus}`);
                    }
                }

            }
        }

        public navigate = (link: dg.restfulApi.Link) => {
            if (link) {
                this.navigationService.navigate(link);
            };
        };
    }

    angular.module('dg.objects').component('objectTasksStatus', {
        bindings: {
            object: '<'
        },
        controller: (ObjectTasksStatusController as any),
        templateUrl: '/digmo/src/objects/object-tasks-status.html'
    });
}